
import React from 'react';
import { FlowRender } from "../flow-render";
import { Text, digitsValidator } from "../prm/text";
import {is_ugma as is_ugma_f, calc_ira_spend_years, is_transfer as is_transfer_f } from "../onboarding-utils";
import { sprintf } from "sprintf-js";
import { MMDDYYYY_to_date } from "../time";
import {get_fake_value} from "../fake";
import { AllNames } from "./shared-prms";

// We're defaulting to 30 year portfolios for UGMA accounts.
const NUM_ACCESS_YEARS_UGMA = "30";

const access_funds_years = new Text(
  AllNames.ACCESS_FUNDS_YEARS_NAME,
  null,
  { path: "random.num", arg0: 5, arg1: 20 }
);

access_funds_years.setValidator(digitsValidator);

const spend_funds_years = new Text(
  AllNames.SPEND_FUNDS_YEARS_NAME,
  null,
  { path: "random.num", arg0: 5, arg1: 10 }
);

spend_funds_years.setValidator(digitsValidator);

class Risk_0 extends FlowRender {

  constructor(index) {
    super(index, [
      access_funds_years,
      spend_funds_years,
    ]);

    access_funds_years.onChangeCallback = this.onChange;
    spend_funds_years.onChangeCallback = this.onChange;
    this.url = "risk_0";
  }

  onChange = (component, newState) => {
    if (!access_funds_years.isBlank(newState) && !spend_funds_years.isBlank(newState)) {
      newState.nextEndpoint = component.getRootUrl() + "/risk_1";
    } else {
      newState.nextEndpoint = "";
    }
  };

  init(componentState, appState, component) {
    super.init(componentState, appState, component);
    const onboarding = component.getOnboardingData();
    const is_ugma = is_ugma_f(onboarding);
    if (is_ugma) {

      if (access_funds_years.getValue(componentState) !== NUM_ACCESS_YEARS_UGMA) {
        access_funds_years.setValue(componentState, NUM_ACCESS_YEARS_UGMA);
        componentState.dirty = true;
      }
    }
  }

  setRandomValues(state, component) {
    const is_ugma = is_ugma_f(component.getOnboardingData(component.props));

    if (!is_ugma) {
      access_funds_years.setValue(state, get_fake_value(access_funds_years.fake));
    }
    spend_funds_years.setValue(state, get_fake_value(spend_funds_years.fake));
  }


  canNavigateNext(component) {
    const highlight_rects = [];
    const is_ugma = is_ugma_f(component.getOnboardingData(component.props));
    const is_transfer = is_transfer_f(component.getOnboardingData());
    const filled_0 = is_ugma || access_funds_years.isFilledElseHighlight(component.state, highlight_rects);
    const filled_1 = spend_funds_years.isFilledElseHighlight(component.state, highlight_rects);

    if (filled_0 && filled_1) {
      const index = component.getOnboardingIndex();
      let segment;

      if (index === 0) {
        segment = "/risk_1";
      } else if (is_transfer) {
        segment = "/crypto";
      } else {
        segment = "/risk_2";
      }
      return component.getRootUrl() + segment;
    }

    component.setState({ highlight_rects });
    return null;
  }

  renderBody = component => {

    const text = "Tell us about your goals";
    const text_1 = "I'd like to start accessing my funds in how many years?";
    const text_2 = "Once I start accessing funds, I'd like to be able to spend "
      + "for how many years after that?";
    const input_style = {
      marginBottom: "2rem",
      width: "10rem",
      textAlign: "center",
    };
    const is_ugma = is_ugma_f(component.getOnboardingData(component.props));

    return (
      <div>
        <div style={{fontSize: "1.5rem"}}>{text}</div>
        <div style={{height: "1rem"}}/>
        { !is_ugma && <div>{text_1}</div> }
        { !is_ugma && <div style={{height: "0.5rem"}}/> }
        { !is_ugma && access_funds_years.renderInput(component, input_style) }
        <div>{text_2}</div>
        <div style={{height: "0.5rem"}}/>
        { spend_funds_years.renderInput(component, input_style) }
      </div>
    )
  }

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Financial Goals", "50%", "954177293")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(this.renderBody(component))}
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

/**
 * Any IRA onboarding can skip this page. Use this to generate the onboarding
 * data. access_funds_years is set to dob_year + 72.5 - current_year
 * spend_funds_years is set to 25.
 * @param dob {String} MM/DD/YYYY format
 */
const set_access_funds_ira = (dob) => {

  const access_years = calc_ira_spend_years(MMDDYYYY_to_date(dob));
  const state = {};
  access_funds_years.initState(state);
  spend_funds_years.initState(state);
  access_funds_years.setValue(state, sprintf("%d", access_years));
  spend_funds_years.setValue(state, "25");
  return {
    ...access_funds_years.saveToState(state),
    ...spend_funds_years.saveToState(state),
  }
}

const set_access_funds_ugma = () => {
  const state = {};
  access_funds_years.initState(state);
  spend_funds_years.initState(state);
  access_funds_years.setValue(state, "30");
  spend_funds_years.setValue(state, "30");
  return {
    ...access_funds_years.saveToState(state),
    ...spend_funds_years.saveToState(state),
  }
}

export { Risk_0, set_access_funds_ira, set_access_funds_ugma };
